import {get as _get,
    isObject as _isObject,
    max as _max,
    zip as _zip,
} from 'lodash';
import PropTypes from 'prop-types';
import writeXlsxFile from 'write-excel-file';

import {routes} from '@constants/routes';
import {EXPORT_EXCEL_URL_FRAGMENT} from '@constants/variables';
import {showPopupMessage} from '@utils/popupMessage/PopupMessageService';


const prepareDataSets = (dataSets) => {
    const data = [];
    const columns = [];

    dataSets.map((dataSet) => {
        const headerRow = [];
        dataSet.columns.map((column) => {
            headerRow.push({
                value: column.title,
                type: String,
                fontWeight: 'bold',
            });

            columns.push({width: column.width.wch + 1});
        });
        data.push(headerRow);

        dataSet.data.map((rowFields) => {
            const dataRow = [];

            rowFields.map((field) => {
                let type = String;
                let extraCellAttributes = {};
                field = String(undefined === field || null === field ? '' : field);

                if ('Yes' === field || 'No' === field) {
                    extraCellAttributes = {align: 'center'};
                } else if ('' !== field && !isNaN(field)) {
                    type = Number;
                    field = Number(field);
                } else if (field.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)) {
                    type = Date;
                    field = new Date(field + ' UTC');
                    extraCellAttributes = {format: 'yyyy-mm-dd hh:mm:ss'};
                } else if (field.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/)) {
                    type = Date;
                    field = new Date(field + ' UTC');
                    extraCellAttributes = {format: 'yyyy-mm-dd hh:mm'};
                } else if (field.match(/^(\d{4})-(\d{2})-(\d{2})$/)) {
                    type = Date;
                    field = new Date(field + ' UTC');
                    extraCellAttributes = {format: 'yyyy-mm-dd'};
                }

                dataRow.push({...{value: field, type: type}, ...extraCellAttributes});
            });
            data.push(dataRow);
        });
    });

    return {data, columns};
};

export const createExportExcelProps = (exportParams) => {
    if (0 === Object.keys(exportParams).length) {
        return {};
    }

    const {filename, titles, parseData, path, dataExport} = exportParams;

    return {
        dataExport,
        dataSet: [{
            columns: titles ? titles.map(title => ({title: title})) : [],
            data: (dataExport && 0 < dataExport.length)
                ? dataExport.map(row => parseData(row))
                : [titles.map((() => ''))],
        }],
        filename,
        url: `${_get(routes, path)}${EXPORT_EXCEL_URL_FRAGMENT}`,
    };
};

export const setColumnsWidth = (data, columns) => {
    if (data.length) {
        const arrayOfColumns = _zip(...data);
        const longestValues = [];

        arrayOfColumns.map(column => longestValues.push(_max(column.map(el => {
            if (null === el || undefined === el) {
                return 0;
            } else if (Array.isArray(el)) {
                return el.join().length;
            } else if (_isObject(el)) {
                return el.value.toString().length;
            } else {
                return el.toString().length;
            }
        }))));

        longestValues.forEach((value, index) => {
            const length = (value < columns[index].title.length) ? columns[index].title.length : value;

            columns[index] = {...columns[index], width: {wch: length}};
        });
    }
};

export const getExcel = (dataSets, filename) => {
    const {data, columns} = prepareDataSets(dataSets);
    writeXlsxFile(data, {
        columns,
        stickyRowsCount: 1,
        fileName: `${filename}.xlsx`,
        sheet: filename.substring(0, 31),
        fontFamily: 'Calibri',
        fontSize: 12,
    }).catch(() => {
        showPopupMessage(
            `Excel export failed. There was an error while exporting '${filename}' to excel.`,
            'error',
            true
        );
    });
};

export const getContent = (originEntryPoint) => {
    if (!originEntryPoint.tournaments && !originEntryPoint.content_categories) {
        return '';
    }

    const separator = ' > ';

    const tournaments = originEntryPoint.tournaments.map(tournament => ([
        tournament.tournament_category.sport?.name,
        tournament.tournament_category?.name,
        tournament?.name,
    ].join(separator)));

    const contentCategories = originEntryPoint.content_categories.map(contentCategory => ([
        contentCategory.parent.parent?.name,
        contentCategory.parent?.name,
        contentCategory?.name,
    ].join(separator)));

    return [...tournaments, ...contentCategories].sort((a, b) => (
        a.toLowerCase() > b.toLowerCase() ? 1 : -1
    )).join('; ');
};

createExportExcelProps.propTypes = {
    exportParams: PropTypes.shape({
        dataExport: PropTypes.array.isRequired,
        filename: PropTypes.string.isRequired,
        parseData: PropTypes.func.isRequired,
        path: PropTypes.string.isRequired,
        titles: PropTypes.array.isRequired,
    }).isRequired,
    routes: PropTypes.object.isRequired,
};
